/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Poniedzia\u0142ek", "Wtorek", "\u015Aroda", "Czwartek", "Pi\u0105tek", "Sobota", "Niedziela"], a = ["Stycze\u0144", "Luty", "Marzec", "Kwiecie\u0144", "Maj", "Czerwiec", "Lipiec", "Sierpie\u0144", "Wrzesie\u0144", "Pa\u017Adziernik", "Listopad", "Grudzie\u0144"], t = "Lata", i = "Rok", d = "Miesi\u0105c", s = "Tydzie\u0144", r = "Dzie\u0144", z = "Dzisiaj", y = "Brak wydarze\u0144", o = "Ca\u0142y dzie\u0144", n = "Usu\u0144", k = "Utw\xF3rz wydarzenie", w = "dddd, D MMMM YYYY", M = { weekDays: e, months: a, years: "Lata", year: "Rok", month: "Miesi\u0105c", week: "Tydzie\u0144", day: "Dzie\u0144", today: "Dzisiaj", noEvent: "Brak wydarze\u0144", allDay: "Ca\u0142y dzie\u0144", deleteEvent: "Usu\u0144", createEvent: "Utw\xF3rz wydarzenie", dateFormat: "dddd, D MMMM YYYY" };
export {
  o as allDay,
  k as createEvent,
  w as dateFormat,
  r as day,
  M as default,
  n as deleteEvent,
  d as month,
  a as months,
  y as noEvent,
  z as today,
  s as week,
  e as weekDays,
  i as year,
  t as years
};
